@if ( !field.hide ) {
<mat-expansion-panel #headerPanel [disabled]='props?.readonly'
    [expanded]="externalPaymentConfig || !!props?.defaultOpen" [class]="['mutara-expansion-panel']"
    [hideToggle]="externalPaymentConfig">
    @if ( !!props.label || !!props.description ) {
    <mat-expansion-panel-header [class]="['mutara-expansion-panel-header', 'lr-pad', props.viewStyle ?? '']">
        <mat-panel-title class="flex-auto">
            <h2 [class]="['mat-headline-2','flex-2']">{{props.label}}{{props.required ? ' *' : ''}}</h2>
            @if (!!cost ) {
            <mat-card-actions class="flex-1" align="end">
                <div class="mutara-lg-strong">{{formattedCost}}</div>
            </mat-card-actions>
            }
        </mat-panel-title>
    </mat-expansion-panel-header>
    }
    <mat-expansion-panel-content [class]="['mutara-expansion-panel-content','lr-pad']">
        <div [align]="props?.align ?? 'start'" [class]="['display-flex', 'flex-full']">
            @if ( inlinePaymentConfig ) {
            <mat-form-field [class]="{'flex-2': true, 'mutara-display-none': payByCheck}" required="true" [appearance]="appearance">
                <mat-label>Cardholder Name *</mat-label>
                <input matInput #cardholderName matInput title="cardholder name" (focus)="createEmbeddedContext()" [formControl]="nameFormControl">
            </mat-form-field>

            <mat-form-field [class]="{'flex-2': true, 'mutara-display-none': payByCheck}" required="true" [appearance]="appearance">
                <mat-label>Card Number *</mat-label>
                <section id="numberContainer" class="cc-data"></section>
                <input matInput title="card number" class="mutara-display-none">
                <mat-hint>Enter card number</mat-hint>
            </mat-form-field>

            <mat-form-field [class]="{'flex-1': true, 'mutara-display-none': payByCheck}" required="true" [appearance]="appearance">
                <mat-label>Security Code *</mat-label>
                <section id="securityContainer" class="cc-data"></section>
                <input matInput title="security code" class="mutara-display-none">
                <mat-hint>3 or 4 digits</mat-hint>
            </mat-form-field>

            <mat-form-field id="expMonth" [class]="{'flex-1': true, 'mutara-display-none': payByCheck}" required="true" [appearance]="appearance">
                <mat-label>Expiration Month *</mat-label>
                <mat-select [(value)]='monthValue'>
                    @for(option of monthList; track option ) {
                    <mat-option [value]='option'>{{getMonthName(option)}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field id="expYear" [class]="{'flex-1': true, 'mutara-display-none': payByCheck}" required="true" [appearance]="appearance">
                <mat-label>Expiration Year *</mat-label>
                <mat-select [(value)]='yearValue'>
                    @for(option of yearList; track option ) {
                    <mat-option [value]='option'>{{option}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            }

            <ng-container #fieldComponent></ng-container>

            <mat-card-actions align="end" [class]="{'flex-full': true, 'mutara-display-none': payByCheck}" [appearance]="appearance">
                <button mat-flat-button type='button' (click)="invokePayment()"
                    [disabled]="!isComplete || isPaid"
                    [color]="buttonColor">{{ props.displayMessage ?? 'Pay Fee' }}</button>
            </mat-card-actions>
        </div>
        <mutara-alert statusType="success" [description]="props.displayMessage ?? props.description"></mutara-alert>
    </mat-expansion-panel-content>
</mat-expansion-panel>
}